module.exports = __webpack_public_path__ + "img/solution_constitute@2x.c63600e9.png";